import _classCallCheck from "/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module paste-from-office/normalizers/mswordnormalizer
 */
import { parseHtml } from "../filters/parse";
import { transformListItemLikeElementsIntoLists } from "../filters/list";
import { replaceImagesSourceWithBase64 } from "../filters/image";
var msWordMatch1 = /<meta\s*name="?generator"?\s*content="?microsoft\s*word\s*\d+"?\/?>/i;
var msWordMatch2 = /xmlns:o="urn:schemas-microsoft-com/i;
/**
 * Normalizer for the content pasted from Microsoft Word.
 *
 * @implements module:paste-from-office/normalizer~Normalizer
 */

var MSWordNormalizer = /*#__PURE__*/function () {
  function MSWordNormalizer() {
    _classCallCheck(this, MSWordNormalizer);
  }

  _createClass(MSWordNormalizer, [{
    key: "isActive",

    /**
     * @inheritDoc
     */
    value: function isActive(htmlString) {
      return msWordMatch1.test(htmlString) || msWordMatch2.test(htmlString);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "execute",
    value: function execute(data) {
      var _parseHtml = parseHtml(data.dataTransfer.getData('text/html')),
          body = _parseHtml.body,
          stylesString = _parseHtml.stylesString;

      transformListItemLikeElementsIntoLists(body, stylesString);
      replaceImagesSourceWithBase64(body, data.dataTransfer.getData('text/rtf'));
      data.content = body;
    }
  }]);

  return MSWordNormalizer;
}();

export { MSWordNormalizer as default };